import { Info } from '@components/icons'
import { useTranslation } from 'next-i18next'

const ExtraInfo = () => {
  const { t } = useTranslation('product')
  const { t: tcommon } = useTranslation('common')

  return (
    <div className="body-2 flex gap-x-1 pt-2 lg:mb-4">
      <div className="z-2">
        <div className="group relative flex flex-col items-start">
          <div className="cursor-pointer">
            <Info />
          </div>
          <div className="absolute hidden w-[340px] pt-6 group-hover:flex">
            <span className="body-2 relative z-10 rounded-sm bg-white p-3 text-xs leading-none shadow-[0_2px_4px_rgba(100,100,100,0.1)]">
              {t('product-chalk-desc')}
            </span>
          </div>
        </div>
      </div>
      <div>{tcommon('we-always-recommend')}</div>
    </div>
  )
}

export default ExtraInfo
